(window as any).process = {
    env: {
        NODE_ENV: "production",
    },
};

import { setBasePath } from "@shoelace-style/shoelace/dist/utilities/base-path.js";
import { Kernel } from "./modules/Kernel";
import { registerIconLibrary } from "@shoelace-style/shoelace/dist/utilities/icon-library.js";
import countries from "i18n-iso-countries";
import countriesLangEn from "i18n-iso-countries/langs/en.json";

countries.registerLocale(countriesLangEn);

registerIconLibrary("local", {
    resolver: (name) => `../assets/local/${name}.svg`,
    mutator: (svg) => svg.setAttribute("fill", "currentColor"),
});

registerIconLibrary("social", {
    resolver: (name) => `/assets/social-icons/${name}.svg`,
    mutator: (svg) => svg.setAttribute("fill", "currentColor"),
});

// Set the base path to lookup assets. In normal production for the app is uses a relative path
// but this can be overridden so the website can also reference the same assets.
if ((window as any).shoelaceBasePath) {
    setBasePath((window as any).shoelaceBasePath);
} else {
    setBasePath("../assets/shoelace");
}

(window as any).cavedb = Kernel.instance();

export { makeEmptyPlace } from "./modules/models/Models";
export * from "./modules/models/Models";
export * from "./modules/models/ILocation";
export * from "./modules/ui/MainWindow/MainWindow";
export * from "./modules/ui/auth/Signin";
export * from "./modules/ui/auth/ChangePassword";
export * from "./modules/ui/auth/ForgotPassword";
export * from "./modules/ui/map/PlacesMap";
export * from "./modules/ui/Compass/Compass";
export * from "./modules/ui/App";
export * from "./modules/ui/PlaceView/PlaceView";
export * from "./modules/ui/PlaceView/PlaceViewDialog";
export * from "./modules/ui/BrowserApp/BrowserApp";
export * from "./modules/ui/PageHeader/PageHeader";

// On Android we want to prevent the app closing when the back button is pressed as this
// just annoying when you do it
const isStandalone =
    !!(navigator as any).standalone || window.matchMedia("(display-mode: standalone)").matches;
const isAndroid = navigator.userAgent.toLowerCase().indexOf("android") > -1;

if (isStandalone && isAndroid) {
    window.addEventListener("load", function () {
        window.history.pushState({}, "");
    });

    window.addEventListener("load", function () {
        window.history.pushState({}, "");
    });

    window.addEventListener("popstate", function () {
        window.history.pushState({}, "");
    });
}
